<div>
  <a href="mailto:{{data.email}}" mat-icon-button matTooltip="{{data.email}}">
    <mat-icon>email</mat-icon>
  </a>

  <a href="tel:{{data.phone}}" mat-icon-button matTooltip="{{data.phone}}" [disabled]="!data.phone">
    <mat-icon>phone</mat-icon>
  </a>
</div>
